/**
 * Hauptmenü-Einträge per Titel ohne Ziel-URL: href auf "#" setzen und
 * Klick/Tastatur/Mittelklick abfangen. Mega-Menü/Hover laufen über das <li>.
 */
(function () {
  const BLOCKED_LABELS = new Set(['shop']);
  const REDIRECT_LABELS = new Map([
    ['gifting', 'https://app.squareup.com/gift/MLVP46SRN5VST/order'],
  ]);

  function normalizeLabel(text) {
    return (text || '').trim().toLowerCase();
  }

  /**
   * @param {HTMLAnchorElement} a
   * @returns {string | null}
   */
  function getNavItemLabel(a) {
    if (!(a instanceof HTMLAnchorElement)) return null;
    if (a.classList.contains('menu-drawer__menu-item--child')) return null;

    if (a.classList.contains('menu-list__link')) {
      const t = a.querySelector('.menu-list__link-title');
      return t ? normalizeLabel(t.textContent) : null;
    }
    if (a.classList.contains('menu-list__item')) {
      return normalizeLabel(a.textContent);
    }
    if (a.classList.contains('menu-drawer__menu-item--mainlist')) {
      const t = a.querySelector('.menu-drawer__menu-item-text');
      return t ? normalizeLabel(t.textContent) : normalizeLabel(a.textContent);
    }
    return null;
  }

  /**
   * @param {HTMLAnchorElement | null} a
   * @returns {string | null}
   */
  function getNavLabelIfHeader(a) {
    if (!(a instanceof HTMLAnchorElement)) return null;
    if (!a.closest('#header-group, header-drawer')) return null;
    return getNavItemLabel(a);
  }

  /**
   * @param {HTMLAnchorElement | null} a
   */
  function isBlockedNavItem(a) {
    const label = getNavLabelIfHeader(a);
    return label != null && BLOCKED_LABELS.has(label);
  }

  /**
   * @param {HTMLAnchorElement | null} a
   * @returns {string | null}
   */
  function getRedirectUrl(a) {
    const label = getNavLabelIfHeader(a);
    if (label == null) return null;
    return REDIRECT_LABELS.get(label) || null;
  }

  function patchHref() {
    document.querySelectorAll('#header-group a, header-drawer a').forEach((el) => {
      if (!(el instanceof HTMLAnchorElement)) return;
      const redirectUrl = getRedirectUrl(el);
      if (redirectUrl) {
        el.setAttribute('href', redirectUrl);
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener noreferrer');
        return;
      }
      if (isBlockedNavItem(el)) {
        el.setAttribute('href', '#');
      }
    });
  }

  /**
   * @param {HTMLAnchorElement | null} a
   */
  function shouldBlock(a) {
    if (!a) return false;
    if (!a.href) return false;
    return isBlockedNavItem(a);
  }

  /**
   * @param {Event} e
   */
  function onPointerOrClick(e) {
    const a = e.target instanceof Element ? e.target.closest('a') : null;
    if (!shouldBlock(/** @type {HTMLAnchorElement | null} */ (a))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  /**
   * @param {KeyboardEvent} e
   */
  function onKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const a = e.target instanceof Element ? e.target.closest('a') : null;
    if (!shouldBlock(/** @type {HTMLAnchorElement | null} */ (a))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  document.addEventListener('click', onPointerOrClick, true);
  document.addEventListener(
    'auxclick',
    function (e) {
      if (e.button !== 1) return;
      onPointerOrClick(e);
    },
    true
  );
  document.addEventListener('keydown', onKeydown, true);

  function init() {
    patchHref();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
